<div class="translations-container app-container">
    <div class="dropdowns">
        <!-- Client Dropdown -->
        <button
            mat-button
            mat-raised-button
            [matMenuTriggerFor]="clientMenu"
            type="button"
        >
            Client
        </button>
        <mat-menu #clientMenu="matMenu">
            <section
                (click)="$event.stopPropagation()"
                *ngFor="let client of clients"
            >
                <mat-radio-button
                    name="selectedClientUuid"
                    ngDefaultControl
                    (click)="onClientSelect(client.clientUuid)"
                    [value]="client.clientUuid"
                    [(ngModel)]="selectedClientUuid"
                    [checked]="selectedClientUuid === client.clientUuid"
                >
                    {{ client.name }}
                </mat-radio-button>
            </section>
        </mat-menu>

        <!-- Game Dropdown -->
        <button
            mat-button
            mat-raised-button
            [matMenuTriggerFor]="gameMenu"
            type="button"
        >
            Game
        </button>
        <mat-menu #gameMenu="matMenu">
            <section
                (click)="$event.stopPropagation()"
                *ngFor="let game of games"
            >
                <mat-radio-button
                    name="selectedGameCode"
                    ngDefaultControl
                    (click)="onGameSelect(game.gameCode)"
                    [value]="game.gameCode"
                    [(ngModel)]="selectedGameCode"
                    [checked]="selectedGameCode === game.gameCode"
                >
                    {{ game.name }}
                </mat-radio-button>
            </section>
        </mat-menu>

        <!-- Language Dropdown -->
        <button
            mat-button
            mat-raised-button
            [matMenuTriggerFor]="languageMenu"
            type="button"
        >
            Language
        </button>
        <mat-menu #languageMenu="matMenu">
            <div class="mat-menu-content">
                <section
                    (click)="$event.stopPropagation()"
                    *ngFor="let language of languages"
                >
                    <mat-radio-button
                        name="selectedLanguage"
                        ngDefaultControl
                        (click)="onLanguageSelect(language)"
                        [value]="language"
                        [(ngModel)]="selectedLanguage"
                        [checked]="selectedLanguage === language"
                    >
                        {{ language }}
                    </mat-radio-button>
                </section>
            </div>
        </mat-menu>

        <button
            mat-raised-button
            color="primary"
            (click)="searchTranslation()"
        >
            Search
        </button>
        <button
            mat-raised-button
            color="primary"
            (click)="resetValues()"
            style="margin-left: 10px"
        >
            Reset filters
        </button>
    </div>

    <!-- Textareas for editing the selected text -->
    <div class="translation-texts">
        <textarea
            [(ngModel)]="translationTextLeft"
            rows="20"
            cols="60"
            [disabled]="true"
            >{{ translationTextLeft }}</textarea
        >
        <textarea
            [(ngModel)]="translationTextRight"
            rows="20"
            cols="60"
            [disabled]="!isEditing"
        ></textarea>
    </div>

    <!-- Buttons for Refresh, Edit, and Save -->
    <div class="action-buttons">
        <button
            mat-raised-button
            color="primary"
            (click)="refresh()"
        >
            Refresh
        </button>
        <button
            mat-raised-button
            color="primary"
            (click)="enableEditing()"
        >
            Edit
        </button>
        <button
            mat-raised-button
            color="primary"
            (click)="saveTranslation()"
        >
            Save
        </button>
    </div>
</div>
